import type { FeedbackMessages } from './en';

const am: FeedbackMessages = {
  qualified: {
    title: 'ይህንን ጥናት ስላጠናቀቁ እናመስግናለን!',
    body1: 'የአሳሽ መስኮቱን መዝጋት ይችላሉ።',
    body2: 'በቅርቡ እርስዎን መልሰን እናይ እንደሆነ እናምናለን።',
    refCode: 'የማጣቀሻ ኮድ: {code}',
  },
  quotaFull: {
    title: 'ይህ ጥናት ተዘግቷል',
    body1: 'በጥናታችን ላይ ላሳዩት ፍላጎት እናመስግናለን።',
    body2: 'ይሁን እንጂ የሚያስፈልጉንን ምላሾች በሙሉ አስቀድመን ተቀብለናል።',
    body3: 'በሚመጡት ጥናቶቻችን ውስጥ እርስዎን ማየት እንፈልጋለን!',
    refCode: 'የማጣቀሻ ኮድ: {code}',
  },
  terminated: {
    title: 'አስተያየትዎን ስላጋሩ እናመስግናለን!',
    body1:
      'በሚመጡት ጥናቶቻችን ውስጥ በቅርቡ እርስዎን ማየት እንፈልጋለን። እስከዚያ ድረስ፣ መልካም ቀን እንመኝልዎታለን።',
    body2: 'እባክዎ የአሳሽ መስኮቱን ይዝጉ።',
    refCode: 'የማጣቀሻ ኮድ: {code}',
  },
  mismatch: {
    title: 'ላሳዩት ፍላጎት እናመስግናለን',
    body1: 'እርስዎ በሚያሳዝን ሁኔታ ለዚህ የተለየ ጥናት ዒላማ ቡድን አካል አይደሉም።',
    body2: 'ይህንን ገጽ መዝጋት ይችላሉ።',
    code: 'ኮድ: {code}',
  },
  error: {
    title: 'ጥያቄዎን ማስተናገድ አልቻልንም',
    linkProblemDetailed:
      'የተከተሉት አገናኝ ችግር እያጋጠመው ነው። በአድራሻ መስመሩ ላይ ያለው አገናኝ ከተሰጠዎት ጋር የሚመሳሰል መሆኑን ያረጋግጡና እንደገና ይሞክሩ።',
    linkProblemGeneric:
      'የተከተሉት አገናኝ ችግር እያጋጠመው ነው። እባክዎ እንደገና ይሞክሩ።',
    contactPerson:
      'ችግሩ ከቀጠለ፣ እባክዎ አገናኙን ካገኙበት ሰው ይህንን ችግር ያሳውቁ።',
    errorCode: 'የስህተት ኮድ: {code}',
  },
};

export default am;
